// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1ZvcP","label":"Completed_label__2Vjem"};